const portalConfig = {
    authenticateEntryForAdmin:"/all-dashboard",
    authenticateEntryDep:"/all-dashboard",
    authenticateEntryTrader:"/my-applications",
    authenticateEntryPannel:"/myApplicationPanel",
    authenticateEntryGCA:"/gca-my-application",
    authenticateSponsor:"/sponsor-reg-menu",
    authenticateAccountant:"/mis-upload",
    unAuthenticateEntry:"/"
}
 
export default portalConfig